import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { GoogleMapsAPIWrapper } from '@agm/core';
@Component({
  selector: 'app-mapdirection',
  templateUrl: './mapdirection.component.html',
  styleUrls: ['./mapdirection.component.css']
})
export class MapdirectionComponent implements OnInit {
  lon: any;
  lat: any;
  lon2: any;
  lat2: any;
  marker: any;
  dir: any;
  mode= 'DRIVING';
  wp= true;
  options = {
    suppressMarkers: true,
    draggable: true,
  };
  constructor(private dialogRef: MatDialogRef <MapdirectionComponent >,
      @Inject(MAT_DIALOG_DATA) public data: any) {
        this.lat = parseFloat(data.lat);
        this.lon = parseFloat(data.lon);
        this.lat2 = parseFloat(data.lato);
        this.lon2 = parseFloat(data.lono);
        this.setMarker();
        this.getDirection();
      }

  ngOnInit() {
  }
  setMarker() {
    this.marker = {'lat': this.lat, 'lon': this.lon};
  }
  public getDirection() {
    this.dir = {
      origin: { lat: this.lat2, lng: this.lon2 },
      destination: { lat: this.lat, lng: this.lon }
    }
  }
}
